import SearchRequestResponseView from "../components/SearchRequestResponseView";
import GlobalFunctions from "./GlobalFunctions";
import SystemAdminInvoiceList from "../components/SystemAdminInvoiceList";
import DashboardPage from "../components/DashboardPage";
import UndoManager from "./UndoManager";
import SettingTab from "../components/SettingTab";
import StaffRequestTab from "../components/StaffRequestTab";
import BillingDetailsView from "../components/BillingDetailsView";
import SupportUserList from "../components/SupportUserList";
import StaffPage from "../components/StaffPage";
import LoginScreen from "../components/LoginScreen";
import SystemAdminRequestList from "../components/SystemAdminRequestList";
import AdminChangePassWordPage from "../components/AdminChangePassWordPage";
import ForgotPasswordPage from "../components/ForgotPasswordPage";
import HomePage from "../components/HomePage";
import HospitalTab from "../components/HospitalTab";

export default class AllPagesUtil {
  public static load(): void {
    GlobalFunctions.AdminChangePassWordPage = AdminChangePassWordPage;

    GlobalFunctions.BillingDetailsView = BillingDetailsView;

    GlobalFunctions.DashboardPage = DashboardPage;

    GlobalFunctions.ForgotPasswordPage = ForgotPasswordPage;

    GlobalFunctions.HomePage = HomePage;

    GlobalFunctions.HospitalTab = HospitalTab;

    GlobalFunctions.LoginScreen = LoginScreen;

    GlobalFunctions.SearchRequestResponseView = SearchRequestResponseView;

    GlobalFunctions.SettingTab = SettingTab;

    GlobalFunctions.StaffPage = StaffPage;

    GlobalFunctions.StaffRequestTab = StaffRequestTab;

    GlobalFunctions.SupportUserList = SupportUserList;

    GlobalFunctions.SystemAdminInvoiceList = SystemAdminInvoiceList;

    GlobalFunctions.SystemAdminRequestList = SystemAdminRequestList;

    UndoManager.load();
  }
}
